module.exports = __webpack_public_path__ + "static/dire-mimic-mtg_clb-6d4eb58c75d9e880d2393b7269afcd81.webp";